import {
  Box,
  Checkbox,
  Image,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from '@astro-ui/components'
import { OutboundSOAddProductSliceType } from 'features/SupplyOrder/redux/outboundSOAddProduct'
import { dateFormat } from 'utils/helpers/date'
import useRow from './useRow'
import InventoryStatusChip from '../../components/InventoryStatusChip'

type RowPropsType = {
  checked?: boolean
  item: OutboundSOAddProductSliceType['data'][number]
}

const Row = ({ checked, item }: RowPropsType) => {
  const { qty, handleChangeQty, handleChangeCheckbox } = useRow({ item })

  return (
    <TableRow>
      <TableCell textAlign="center">
        <Checkbox checked={checked} onChange={handleChangeCheckbox} />
      </TableCell>
      <TableCell>
        <Box display="flex" gap="8px" alignItems="center">
          <Image src={item.productImage || ''} width="40px" height="40px" mr={12} />
          <Typography>{item.productName}</Typography>
        </Box>
        {checked && !qty && (
          <Box mt="8px">
            <Typography variant="caption-default" color="error.main">
              Qty harus diisi atau tidak boleh 0
            </Typography>
          </Box>
        )}
        {checked && Number(qty) > item.productStock && (
          <Box mt="8px">
            <Typography variant="caption-default" color="error.main">
              Qty tidak boleh melebihi stok yang tersedia
            </Typography>
          </Box>
        )}
      </TableCell>
      <TableCell>
        <Typography>{item.productSku}</Typography>
      </TableCell>
      <TableCell>
        <Typography>
          {item?.productExpiryDate
            ? dateFormat({
                date: new Date(item.productExpiryDate),
                format: 'DD MMM YYYY',
              })
            : '-'}
        </Typography>
      </TableCell>
      <TableCell textAlign="center">
        <Typography>{item.productStock}</Typography>
      </TableCell>
      <TableCell textAlign="center" backgroundColor="#FFF8E7">
        <TextField
          sx={{ width: '80px' }}
          placeholder="0"
          value={qty}
          onChange={(e) => handleChangeQty(e.target.value)}
        />
      </TableCell>
      <TableCell textAlign="center">
        <InventoryStatusChip
          label={item.productInventoryStatus}
          status={item.productInventoryStatus?.toLowerCase() === 'available' ? 'SUCCESS' : 'DANGER'}
        />
      </TableCell>
      <TableCell textAlign="center">
        <Typography>{item.productInventoryNote || '-'}</Typography>
      </TableCell>
    </TableRow>
  )
}

export default Row
